<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
         <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3" @click="openCloseMenuMobile">
            <i class="fa fa-bars"></i>
        </button> 
        <searchSystem :list="filteredList" @input="handleInput"></searchSystem>
        <ul class="navbar-nav ml-auto">

            <!-- Nav Item - Search Dropdown (Visible Only XS) -->
            <li class="nav-item dropdown no-arrow d-sm-none">
                <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-search fa-fw"></i>
                </a>
                <!-- Dropdown - Messages -->
                <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                    aria-labelledby="searchDropdown">
                    <searchSystem :list="filteredList" @input="handleInput"></searchSystem>
                </div>
            </li>

            <!-- Nav Item - Alerts -->
            <li class="nav-item dropdown no-arrow d-none d-sm-block  mt-4 mr-3">
                <small>Sessão expira em: {{ expire_in }}</small>
            </li>
            <li class="nav-item dropdown no-arrow mx-0">
                <a class="nav-link dropdown-toggle" href="#" id="alertsDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-bell fa-fw"></i>
                    <!-- Counter - Alerts -->
                    <span class="badge badge-primary badge-counter" v-if="number_notification_no_read <= 0">{{
                        number_notification_no_read }}</span>
                    <span class="badge badge-danger badge-counter" v-else>{{ number_notification_no_read }}</span>
                </a>
                <!-- Dropdown - Alerts -->
                <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                    aria-labelledby="alertsDropdown">
                    <h6 class="dropdown-header">
                        Notificações
                    </h6>
                    <div v-for="(notification, index) in notifications" :key="index">
                        <a class="dropdown-item d-flex align-items-center" href="#"
                            @click="openModalViewNotification(notification.id)">
                            <div class="mr-3">
                                <div class="icon-circle" :class="notification.read ? 'bg-success' : 'bg-danger'">
                                    <i class="fas text-white"
                                        :class="notification.read ? 'fa-check' : 'fa-exclamation'"></i>
                                </div>
                            </div>
                            <div>
                                <div class="small text-gray-500">{{ notification.created_at_formatted }} <span
                                        class="badge badge-secondary" v-if="notification.read">(Lida)</span></div>
                                <span class="font-weight-bold">{{ notification.title }}</span>
                            </div>
                        </a>
                    </div>
                    <div v-if="notifications.length <= 0">
                        <div class="dropdown-item d-flex align-items-center">
                            <div class="mr-3">
                                <div class="icon-circle bg-primary">
                                    <i class="fas fa-check text-white"></i>
                                </div>
                            </div>
                            <div>
                                <span class="font-weight-bold">Não há notificações no momento.</span>
                            </div>
                        </div>

                    </div>
                    <router-link class="dropdown-item text-center small text-gray-500" to="notification-user">Mostrar
                        todas as notificações</router-link>
                </div>
            </li>

            <!-- Nav Item - Messages -->
            <li class="nav-item dropdown no-arrow mx-1">
               
                <!-- Dropdown - Messages -->
                <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                    aria-labelledby="messagesDropdown">
                    <h6 class="dropdown-header">
                        Mensagens
                    </h6>
                    <span class="dropdown-item text-center small text-gray-500" href="#">Nenhuma mensagem
                        encontrada</span>
                </div>
            </li>

            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">
                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ name_user }}</span>
                    <img class="img-profile rounded-circle" src="img/undraw_profile.svg">
                </a>
                <!-- Dropdown - User Information -->
                <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                    <!-- <a class="dropdown-item" href="#">
                        <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                        Meu perfil
                    </a> -->
                    <!-- <a class="dropdown-item" href="#">
                        <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                        Atualizar senha
                    </a> -->
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click="logout()" data-toggle="modal" data-target="#logoutModal">
                        <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                        Sair
                    </a>
                </div>
            </li>
        </ul>
    </nav>
    <ViewNotification :modalDisplayViewNotification="modalDisplayViewNotification" :title="titleNotification"
        :description="descriptionNotification" @update:closeModalNotification="closeModalNotification"
        @update:markNotificationRead="markNotificationRead" :notification_by="notification_by" :read="readNotification"
        :created_at="createdAtNotification" :notification_id="notification_id">
    </ViewNotification>
</template>

<script>
import searchSystem from './search-system.vue';
import api from '@/api.js';
import ViewNotification from '../notification/view-notification.vue';
import Loading from 'vue-loading-overlay';
import { menu } from '../../menu.js'

export default {
    components: { Loading, searchSystem, ViewNotification },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            filterInput: null,
            list: [],
            name_user: 'Usuário',
            expire_in: '...',
            number_notification_no_read: 0,
            notifications: [],
            polling: null,
            modalDisplayViewNotification: 'none',
            titleNotification: '',
            descriptionNotification: '',
            notification_by: '',
            readNotification: false,
            createdAtNotification: '',
            notification_id: 0
        }
    },
    mounted() {
        if (localStorage.getItem('name')) {
            this.name_user = localStorage.getItem('name');
        }

        if (localStorage.getItem('expire_in')) {
            this.expire_in = localStorage.getItem('expire_in');
        }
        this.loadNotifications();
    },
    created() {
        this.polling = setInterval(() => {
            this.loadNotifications();
        }, 60000);
    },
    beforeUnmount() {
        clearInterval(this.polling); // Clear interval when component is unmounted
    },
    methods: {
        onCancel() { },
        handleInput(e) {
            this.filterInput = e
        },
        openCloseMenuMobile(){
            menu.changeToggled();
        },
        loadNotifications() {
            api.get('notification-user')
                .then(response => {
                    this.notifications = response.data.notifications;
                    this.number_notification_no_read = response.data.amount_notifications_no_read;
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        },
        logout() {
            api.post('/auth/logout')
                .then(() => {
                    this.$notify({
                        title: "Sucesso",
                        text: "Sessão encerrada com sucesso!",
                        type: 'success'
                    });
                    localStorage.removeItem('token');
                    localStorage.removeItem('email');
                    localStorage.removeItem('name');
                    localStorage.removeItem('role');
                    localStorage.removeItem('expire_in');
                    localStorage.removeItem('change_password');
                    localStorage.removeItem('two_authentication_factor');
                }).catch(error => {
                    if (error.status == 401) {
                        this.$notify({
                            title: "Falha",
                            text: "Sessão já encerrada!",
                            type: 'error'
                        });
                    } else if (error.status == 429) {
                        this.$notify({
                            title: "Falha",
                            text: "Foram realizadas várias tentativas de finalização de sessão! Aguarde alguns instantes e tente novamente!",
                            type: 'error'
                        });
                    } else if (error.status == 500) {
                        this.$notify({
                            title: "Falha",
                            text: "Não foi possível encerrar a sessão! Por gentileza, contacte o suporte técnico para mais detalhes",
                            type: 'error'
                        });
                    }
                })
            this.$router.push('/login');
        },

        openModalViewNotification(notification_id) {
            this.isLoading = true;
            api.get('notification-user/' + notification_id)
                .then(response => {
                    const notification = response.data.notification;
                    this.titleNotification = notification.title;
                    this.descriptionNotification = notification.description;
                    this.notification_by = notification.notification_created_by;
                    this.readNotification = notification.read;
                    this.createdAtNotification = notification.created_at_formatted;
                    this.notification_id = notification.id;
                    this.modalDisplayViewNotification = 'block';
                    this.isLoading = false;
                    this.loadNotifications();
                })
                .catch(error => {
                    this.isLoading = false;
                    console.error("Error fetching data:", error);
                });

        },
        closeModalNotification(value) {
            this.modalDisplayViewNotification = value;
        },
        markNotificationRead(notification_id) {
            api.post('notification-user/' + notification_id)
                .then(() => {
                    this.modalDisplayViewNotification = 'none';
                    this.loadNotifications();
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }
}
</script>

<style></style>